import type { Caching } from "@/lib/caching"

export const buildCachedPayload = <DataType>({
  cachedAt = Date.now(),
  data,
  expiresAt,
  expiry,
}: {
  data: DataType
} & Partial<Caching.Metadata>): Caching.Payload<DataType> => {
  return {
    caching: {
      cachedAt,
      expiresAt: expiresAt || (expiry ? cachedAt + expiry : undefined),
      expiry,
    },
    data,
  }
}
